// extracted by mini-css-extract-plugin
export default {"fade-in":"ColorSelector_fade-in__km2qR","fadeInAnimation":"ColorSelector_fadeInAnimation__6cGCb","image":"ColorSelector_image__0-M9p"};